export const escapeCsvField = (value: string): string => {
    if (/[",\n\r]/.test(value)) return `"${value.replace(/"/g, '""')}"`;
    return value;
};

export interface CsvColumn {
    key: string;
    label: string;
}

export const buildCsv = <T>(
    columns: CsvColumn[],
    rows: T[],
    getCellValue: (row: T, colKey: string) => string
): string => {
    const header = columns.map((c) => escapeCsvField(c.label)).join(',');
    const body = rows
        .map((row) =>
            columns
                .map((c) => escapeCsvField(getCellValue(row, c.key)))
                .join(',')
        )
        .join('\n');
    return body ? `${header}\n${body}` : header;
};

export const sanitizeFileName = (s: string): string =>
    s.replace(/[^a-zA-Z0-9_.-]+/g, '_').replace(/^_+|_+$/g, '') || 'table';

export const downloadCsv = (fileName: string, content: string): void => {
    const blob = new Blob([`﻿${content}`], {type: 'text/csv;charset=utf-8;'});
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${sanitizeFileName(fileName)}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
